module.exports = __webpack_public_path__ + "media/images/icons/filled/home-2ea3634ec34ed1b603083d819518743d.svg";